module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('header', [_c('div', {
    staticClass: "title"
  }, [_vm._v("醉品商城")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('mt-search', {
    attrs: {
      "cancel-text": "取消",
      "placeholder": "搜索您想要的产品"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "swipe"
  }, [_c('mt-swipe', {
    attrs: {
      "auto": 4000
    }
  }, _vm._l((_vm.imgs), function(img) {
    return _c('mt-swipe-item', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (img),
        expression: "img"
      }]
    })])
  }))], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "part3"
  }, [_c('h3', [_vm._v("8大热销茶叶品类")]), _vm._v(" "), _c('p', [_vm._v("总有你想不到的低价")]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "list-img"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item),
        expression: "item"
      }]
    })])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "part4"
  }, [_c('div', {
    staticClass: "part4-content"
  }, [_c('div', {
    staticClass: "newProducts"
  }, [_c('h3', [_vm._v(_vm._s(_vm.products.title))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.products.note))]), _vm._v(" "), _vm._l((_vm.products.data), function(product, index) {
    return _c('div', {
      staticClass: "product",
      on: {
        "click": function($event) {
          _vm.handleSelected(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": product.img
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "product-p1"
    }, [_vm._v(_vm._s(product.bigContent))]), _vm._v(" "), _c('p', {
      staticClass: "product-p2"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.smallContent)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "money"
    }, [_c('i', {
      staticClass: "fa fa-jpy",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(product.price.toFixed(2)))])])])
  })], 2)])]), _vm._v(" "), _c('NavBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "part1"
  }, [_c('div', {
    staticClass: "text-content"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o check-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("全场商品90天保价")])]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o check-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("30天无忧退换货")])]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o check-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("满59元免运费")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "part2"
  }, [_c('div', {
    staticClass: "part2-content"
  }, [_c('div', {
    staticClass: "part2-img"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/img/4.png")
    }
  })]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/img/5.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "left"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f71a18b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home.vue
// module id = 220
// module chunks = 1